import { LocationState } from './location.types';

export const locationInitialStore: LocationState = {
    currentLocation: '',
    isDell: false,
};
